export default {"src":"/_next/static/image/public/images/flags/flag_54.afaf9e4e4097397c6a7cca0f3c3cf70f.svg","height":16,"width":25};